import { p as proxyCustomElement, H, h, c as Host } from './p-23afa4c1.js';
import { d as defineCustomElement$2 } from './p-0f8558ea.js';
import { b as bem } from './p-a05fe53c.js';
import { t as transformTagName } from './p-d1ae9dd0.js';

const cosmosOptgroupCss = ".cosmos-optgroup{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:2px}.cosmos-optgroup__label{--cosmos-text-color:var(--cosmos-optgroup-color);--cosmos-text-font-family:var(--cosmos-optgroup-font-family);--cosmos-text-font-size:var(--cosmos-optgroup-font-size);--cosmos-text-font-style:var(--cosmos-optgroup-font-style);--cosmos-text-font-weight:var(--cosmos-optgroup-font-weight);--cosmos-text-letter-spacing:var(--cosmos-optgroup-letter-spacing);--cosmos-text-line-height:var(--cosmos-optgroup-line-height);--cosmos-text-text-transform:var(--cosmos-optgroup-text-transform);padding:12px 12px 8px 12px}.cosmos-optgroup--disabled .cosmos-optgroup__label{--cosmos-text-color:rgba(0, 15, 30, 0.6)}.cosmos-optgroup--disabled.cosmos-optgroup--appearance-light .cosmos-optgroup__label{--cosmos-text-color:rgba(255, 255, 255, 0.6)}";
const CosmosOptgroupStyle0 = cosmosOptgroupCss;

const generateClassNames = bem('cosmos-optgroup');
const CosmosOptgroup$1 = /*@__PURE__*/ proxyCustomElement(class CosmosOptgroup extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.handleSlotChange = () => {
            this.initOptions();
        };
        this.appearance = 'dark';
        this.disabled = undefined;
        this.label = undefined;
    }
    initOptions() {
        if (this.disabled) {
            const options = Array.from(this.element.querySelectorAll(transformTagName('cosmos-option')));
            options.forEach((option) => {
                option.disabled = true;
            });
        }
    }
    componentWillLoad() {
        this.initOptions();
    }
    render() {
        return (h(Host, { key: '92eac7d7b4663033b82d79ede91c0e9aec4e55c5', role: "group", "aria-label": this.label }, h("div", { key: '78619cfa364a2586b965f532851b70c64fc04492', class: generateClassNames({ disabled: this.disabled, appearance: this.appearance }), part: "base" }, h("div", { key: '6573c45da7c0b8f02679176a480b827f97528ab3', class: generateClassNames('label') }, h("cosmos-text", { key: 'a6e6999718c3ef323c3e09e0b0ed4c24630bde92', exportparts: "base: label", size: "x-small", weight: "medium", clamp: 1, appearance: this.appearance }, this.label)), h("slot", { key: '63c55ee15d82789610070023cf6a077c290492e9', onSlotchange: this.handleSlotChange }))));
    }
    get element() { return this; }
    static get style() { return CosmosOptgroupStyle0; }
}, [1, "cosmos-optgroup", {
        "appearance": [513],
        "disabled": [516],
        "label": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-optgroup", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-optgroup":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosOptgroup$1);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosOptgroup = CosmosOptgroup$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosOptgroup, defineCustomElement };
